import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ProfileNav.styled';
import { getProfileNavItems } from './ProfileNav.constants';
import { isProfileNavItemActive } from './ProfileNav.helpers';
import { ExitIcon } from '@/components/UI/Icons/Icons';
import { useAuth } from '@/hooks/useAuth';

type ProfileNavProps = {
  currentPath: string;
};

export function ProfileNav({ currentPath }: ProfileNavProps) {
  const { t } = useTranslation();
  const { logoutUser } = useAuth();
  const navItems = getProfileNavItems(t);

  function handleLogout(event: React.MouseEvent) {
    event.preventDefault();
    logoutUser();
  }

  return (
    <S.Nav aria-label="Profile menu">
      {navItems.map(item => (
        <S.NavItem
          key={item.href}
          href={item.href}
          $isActive={isProfileNavItemActive(currentPath, item.href)}
        >
          {item.icon}
          <S.NavTitle>{item.title}</S.NavTitle>
        </S.NavItem>
      ))}

      <S.Divider />

      <S.LogoutButton type="button" onClick={handleLogout}>
        <ExitIcon />
        <S.NavTitle>{t('common.exit')}</S.NavTitle>
      </S.LogoutButton>
    </S.Nav>
  );
}
